import labels from './pl.json';

export const CLIENT_LABELS = labels as typeof labels;
